import { novoBairroVazio } from "../models/atribuirRegiaoModel"
import type { AtribuirRegiaoModel } from "../models/atribuirRegiaoModel"
import {
    AtribuirRegiaoActionModel,
    AtribuirRegiaoActionsTypes,
} from "./atribuirRegiaoActions"

export function atribuirRegiaoReducer(
    state: AtribuirRegiaoModel,
    action: AtribuirRegiaoActionModel
): AtribuirRegiaoModel {
    switch (action.type) {
        case AtribuirRegiaoActionsTypes.CARREGAR_BAIRROS:
            return { ...state, bairros: action.payload }

        case AtribuirRegiaoActionsTypes.CARREGAR_CIDADES_ESTABELECIMENTO:
            return { ...state, cidadesEstabelecimento: action.payload }

        case AtribuirRegiaoActionsTypes.CARREGAR_TODAS_CIDADES:
            return { ...state, todasCidades: action.payload }

        case AtribuirRegiaoActionsTypes.ADICIONAR_BAIRRO:
            return { ...state, bairros: [...state.bairros, novoBairroVazio(state.bairros.length)] }

        case AtribuirRegiaoActionsTypes.ATUALIZAR_BAIRRO: {
            const { index, campo, valor } = action.payload
            return {
                ...state,
                bairros: state.bairros.map((bairro, i) =>
                    i === index ? { ...bairro, [campo]: valor } : bairro
                ),
            }
        }

        case AtribuirRegiaoActionsTypes.REMOVER_BAIRRO:
            return {
                ...state,
                bairros: state.bairros.filter((_, i) => i !== action.payload.index),
            }

        default:
            return state
    }
}
